package com.daytimegaming.ourdailyfinances.data.repository

import com.daytimegaming.ourdailyfinances.data.network.service.EventStreamService
import com.daytimegaming.ourdailyfinances.domain.model.ServerEvent
import com.daytimegaming.ourdailyfinances.domain.repository.EventRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class EventRepositoryImpl(
    private val service: EventStreamService
) : EventRepository {
    override fun getServerEvents(): Flow<ServerEvent> {
        return service.getEventsStream().map { dto ->
            ServerEvent(
                type = dto.type,
                event = dto.event,
                dashboardId = dto.dashboardId,
                accountId = dto.accountId,
            )
        }
    }
}
